"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Butticon = void 0;
var butticon_1 = require("./butticon");
Object.defineProperty(exports, "Butticon", { enumerable: true, get: function () { return butticon_1.Butticon; } });
//# sourceMappingURL=index.js.map